<div class="layout {{layoutClass}}" [class.image]="hasImage" tappable (click)="handleClick()">
  <div class="type left solid-bar" *ngIf="!leftImage" [style.backgroundColor]="leftColor"></div>
  <div class="type blur" *ngIf="hasBlur" [style.backgroundImage]="reference.blurredImage | safe:'style'"></div>
  <swiper-container [id]="'propertyLayoutSwiper' + textMode" *ngIf="listing" init="false" class="propertylayout swiper">
    <swiper-slide class="swiper-slide" *ngFor="let listingImage of listingImagesArr; let i = index">
      <div class="type left" *ngIf="leftImage">
        <div class="burns play" [style.backgroundImage]="listingImage | safe:'style'"></div>
      </div>
      <div class="type right no-image" *ngIf="!rightImage" [style.backgroundColor]="rightColor"></div>
      <div class="type right" *ngIf="rightImage">
        <div class="burns play" [style.backgroundImage]="listingImage | safe:'style'"></div>
      </div>
      <div class="type right overlay" *ngIf="showOverlay">
        <div class="label">
          <div class="label1">Property Photo</div>
          <div class="label2">Placeholder</div>
        </div>
        <div class="overlay-icon">
          <img src="assets/imgs/profile_stub_photo_overlay.svg" />
        </div>
      </div>
    </swiper-slide>
  </swiper-container>

  <div class="type img" *ngIf="logoFile">
    <div class="logo" [style.backgroundImage]="logoFile | safe:'style'"></div>
  </div>
  <div class="type text1" [style.color]="textColor">{{textValue}}</div>
</div>